module.exports = __webpack_public_path__ + "static/kalpanchart-desk-8f25ac5ccd58dc2c9d44a3b802fc54ed.png";